import {
    getAccounts,
    getDraft,
    getDraftPreview,
    getDrafts,
    getFile,
    getTasksByDraftId,
} from "@/entities/DataAssociation/DataAssociation.queries";
import { useEffect } from "react";
import { useRouter } from "@/utils";
import {
    draftAtom,
    draftListAtom,
    existingAccountsAtom,
    isReadonlyAtom,
    labelingParamsAtom,
    readOnlyDraftAtom,
    selectedFileAtom,
    tasksAtom,
} from "../state";
import { useApiQueryWithAtom } from "@/api/hooks/useApiQuery/useApiQueryWithAtom";
import { useAtom, useAtomValue } from "jotai";
import { connectorFilesAtom, uploadsAtom } from "../state/files.state";
import { getConnectorFiles, getUploads } from "../labeling.queries";

export function useLabelingHydration() {
    const router = useRouter();
    const [labelingParams, setLabelingParams] = useAtom(labelingParamsAtom);
    const isReadonly = useAtomValue(isReadonlyAtom);
    const { selectedFileId, selectedDraftId } = labelingParams;
    useApiQueryWithAtom(getDraftPreview, readOnlyDraftAtom, {
        enabled: !!selectedFileId && isReadonly,
    });
    useApiQueryWithAtom(getDraft, draftAtom, {
        enabled: !!selectedFileId && !isReadonly && !!selectedDraftId,
    });
    useApiQueryWithAtom(getAccounts, existingAccountsAtom);
    useApiQueryWithAtom(getTasksByDraftId, tasksAtom, {
        enabled: !!selectedDraftId,
    });
    useApiQueryWithAtom(getFile, selectedFileAtom, {
        enabled: !!selectedFileId,
    });
    useApiQueryWithAtom(getUploads, uploadsAtom, {
        enabled: !!router.params.companyId,
        key: [
            "/file/data-association/file-list/uploads",
            router.params.companyId || "",
        ],
    });
    useApiQueryWithAtom(getConnectorFiles, connectorFilesAtom, {
        enabled: !!router.params.companyId,
        key: [
            "/file/data-association/file-list/connectors",
            router.params.companyId || "",
        ],
    });
    // useApiQueryWithAtom(getConnectors, connectorsAtom, {
    //     enabled: !!router.params.companyId,
    // });
    useApiQueryWithAtom(getDrafts, draftListAtom, {
        enabled: !!router.params.companyId,
    });

    useEffect(() => {
        setLabelingParams({
            selectedDraftId: router.params.draftId,
            selectedFileId: router.params.fileId,
        });
    }, [router.params.draftId, router.params.fileId, setLabelingParams]);
}
